import {APP_ROUTES} from '@/utils_legacy/routes';

import {CookiePreferences} from './types';

export const OPEN_COOKIE_PREFERENCES_EVENT = 'open-cookie-preferences';

export const MODAL_STATE = {
  initial: 'initial',
  preference: 'preference',
} as const;

export const INITIAL_MODAL_PREFERENCES: CookiePreferences = {
  statistics: false,
  marketing: false,
};

export const COOKIE_SECTIONS = [
  {
    key: 'essential',
    title: 'Essential',
    description:
      'These tools are necessary for the website/app to function and thus cannot be switched off. They are usually set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling out forms.',
    required: true,
  },
  {
    key: 'statistics',
    title: 'Statistics',
    description:
      'These cookies help us understand how visitors use the app/website, so we can improve performance and user experience. Data is anonymized.',
    required: false,
  },
  {
    key: 'marketing',
    title: 'Marketing',
    description:
      'These cookies allow us to show relevant content and ads based on your interests and measure campaign effectiveness. Data may be shared with partners.',
    required: false,
  },
] as const;

export const SUPPRESSED_COOKIE_BANNER_PATHS: ReadonlySet<string> = new Set([
  APP_ROUTES.PrivacyPolicyGroup,
  APP_ROUTES.PrivacyPolicyInc,
  APP_ROUTES.UnderMaintenance,
  APP_ROUTES.BuildInfo,
  APP_ROUTES.ErrorBanned,
  APP_ROUTES.ErrorVPN,
  APP_ROUTES.AmbassadorAgreement,
  APP_ROUTES.CookiePolicy,
  APP_ROUTES.TermsOfServiceGroup,
  APP_ROUTES.TermsOfServiceInc,
  APP_ROUTES.CommunityGuidelines,
  APP_ROUTES.ContactsInc,
  APP_ROUTES.ContactsGroup,
  APP_ROUTES.Push,
  APP_ROUTES.PayWallBackupPayment,
  APP_ROUTES.ResumeSignup,
  APP_ROUTES.SharedLink,
  APP_ROUTES.EmailConfirmation,
  APP_ROUTES.SignInContinue,
]);
